import React from 'react';
import { DataGrid, frFR, enUS } from '@mui/x-data-grid';
import { DataGridProps } from '@mui/x-data-grid/models/props/DataGridProps';
import sxDataGrid from '../styles/sx/sxDataGrid';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import sxDataGridDark from '../styles/sx/sxDataGridDark';

type CAppDataGridProps = DataGridProps & {
	color?: 'inherit' | 'primary' | 'secondary';
	displayColumns?: string[];
};

const CAppDataGrid = (props: CAppDataGridProps) => {
	const { displayColumns, color, rows, ...otherProps } = props;
	const theme = useTheme();
	const { i18n } = useTranslation();

	const sxData =
		color === 'primary' || theme.palette.mode === 'dark'
			? {
					...sxDataGrid(theme),
					...sxDataGridDark(),
			  }
			: sxDataGrid(theme);

	return (
		<DataGrid
			rows={rows}
			headerHeight={45}
			rowHeight={45}
			{...otherProps}
			density="standard"
			sx={{
				...sxData,
				...otherProps.sx,
			}}
			localeText={
				i18n.language === 'fr'
					? frFR.components.MuiDataGrid.defaultProps.localeText
					: enUS.components.MuiDataGrid.defaultProps.localeText
			}
			columns={
				displayColumns
					? _.sortBy(
							otherProps.columns.filter((x) => displayColumns.includes(x.field)),
							(o) => displayColumns.indexOf(o.field),
					  )
					: otherProps.columns
			}
		/>
	);
};

export default CAppDataGrid;
